var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';
import { classNames } from '@progress/kendo-react-common';
/**
 * Represents the DateHeaderCell component.
 */
export var DateHeaderCell = React.forwardRef(function (props, ref) {
    var _a = props.as, Component = _a === void 0 ? defaultProps.as : _a, other = __rest(props, ["as"]);
    var element = React.useRef(null);
    var target = React.useRef(null);
    var intl = useInternationalization();
    var className = React.useMemo(function () { return classNames('k-scheduler-cell k-heading-cell', props.className); }, [props.className]);
    React.useImperativeHandle(target, function () { return ({
        element: (element.current && element.current.element) ? element.current.element : element.current,
        props: props
    }); });
    React.useImperativeHandle(ref, function () { return target.current; });
    return (React.createElement(Component
    // Consider using `react-is` to check if the component accepts a ref, to avoid console warning
    , __assign({ 
        // Consider using `react-is` to check if the component accepts a ref, to avoid console warning
        ref: Component !== defaultProps.as ? undefined : element }, other, { className: className }),
        React.createElement("span", { className: "k-link k-nav-day" }, intl.formatDate(props.date, props.format))));
});
var defaultProps = {
    as: React.forwardRef(function (_a, ref) {
        var as = _a.as, format = _a.format, start = _a.start, end = _a.end, props = __rest(_a, ["as", "format", "start", "end"]);
        return React.createElement("div", __assign({}, props, { ref: ref }));
    }),
    format: 'd'
};
DateHeaderCell.defaultProps = defaultProps;
DateHeaderCell.displayName = 'KendoReactSchedulerDateHeaderCell';
//# sourceMappingURL=DateHeaderCell.js.map